// TODO: credit https://github.com/lezer-parser/common/blob/main/src/parse.ts

import { EditorState } from "@codemirror/state";
import { SyntaxNode } from "@lezer/common";
import { Fragment } from "@tab-edit/model";
import { NodeBlueprint } from "../parsing/nodes/generator/blueprint";
import { NodeGenerator } from "../parsing/nodes/generator";
import { ASTFragmentCursor } from "./cursors/node_cursor";
import { LinearParser } from "../parsing/nodes/linear-parser";
import { SourceNode } from "./nodes/source-node";

export class ASTFragment extends Fragment {
    private linearParser: LinearParser|null = null; // TODO: think of a way to make linearParser always defined (make the type LinearParser and not LinearParser|null)

    get nodeSet() { return this.linearParser?.nodeSet || []; }

    /**
     * Advances the parser by doing a chunk of parse work.
     * @returns true if parsing work was done, false if parsing is done.
     */
    advance(): boolean {
        if (this.linearParser?.advance()) {
            return true;
        }
        return false;
    }

    /**
     * Creates an unparsed TabFragment object that can be incrementally parsed 
     * by repeatedly calling the TabFragment.advance() method.
     * @param node source node from which parsing begins
     * @param editorState the EditorState from which the syntaxNode was obtained
     * @param blueprint the blueprint used to create the ASTNodeDescriptor structure
     * @returns an unparsed TabFragment object
     */
    static startParse(node: SyntaxNode, editorState: EditorState, blueprint: NodeBlueprint): ASTFragment | null {
        if (!blueprint.anchors.has(node.name)) return null;
        const fragment = new ASTFragment(node.from, node.to)
        fragment.linearParser = new LinearParser(new NodeGenerator(blueprint, editorState.doc), new SourceNode(node, fragment.from));
        return fragment;
    }

    /**
     * Creates a cursor for exploring the nodes of the Fragment.
     * @returns A cursor cursor for the parsed content or a blank cursor if parsing is not done yet.
     */
    cursor() {
        if (this.linearParser?.isDone) {
            return new ASTFragmentCursor(this);
        }
        return ASTFragmentCursor.dud;
    }

    createOffsetCopy(offset: number): ASTFragment {
        const copy = new ASTFragment(this.from+offset, this.to+offset);
        copy.linearParser = this.linearParser;
        return copy;
    }

    get isBlankFragment() { return !this.linearParser }
    static createBlankFragment(from: number, to: number) {
        return new ASTFragment(from, to);
    }

    get isParsed() { return this.isBlankFragment || this.linearParser!.isDone }
}